import "./LoginTitle.scss";

type LoginTitleProps = {
  title?: string;
  subtitle?: string;
};

const LoginTitle = ({
  title = "BMD Chat AI",
  subtitle = "Đăng nhập",
}: LoginTitleProps) => (
  <div className="login-title">
    <h2 className="login-title__heading">{title}</h2>
    <p className="login-title__subtitle">{subtitle}</p>
  </div>
);

export default LoginTitle;
